export const employments = [
    {
        id: 3,
        title: 'Frontend Developer, para Simposio Internacional',
        description: 'Creación de un portal web donde la cual, mediante un registro de asistentes, tienen el acceso a las videosconferencias realizadas en el mes de diciembre del 2022. Se utilizó el framework VueJs, consumiendo la API Google Sheets.',
        date: 'Octubre 2022 - Diciembre 2022'
    },
    {
        id: 2,
        title: 'Frontend dev, para Usual',
        description: 'Actualizado de stock, añadiendo nuevos productos en una landing page de una óptica, haciendo uso del framework VueJs.',
        date: 'Junio 2022 - Agosto 2022'
    },
    {
        id: 1,
        title: 'Frontend dev, Rooftop para Animaedu',
        description: 'Me desempeñé principalmente como desarrollador frontend, haciendo uso del framework VueJs.',
        date: 'Marzo 2021 - Diciembre 2022'
    },
    {
        id: 0,
        title: 'Frontend dev, Rooftop para Sportivo Belgrano',
        description: 'Estuve como desarrollador web frontend, haciendo uso de Html, Css y un poco de Javascript. Dando así mis primeros pasos en el ámbito laboral, trabajando para desarrollar una e-commerce, propia de la institución deportiva.',
        date: 'Diciembre 2020 - Marzo 2021 '
    },
]